import { render } from "./IssueHoupiaoList.vue?vue&type=template&id=96a0eb9c&scoped=true&ts=true"
import script from "./IssueHoupiaoList.vue?vue&type=script&lang=ts"
export * from "./IssueHoupiaoList.vue?vue&type=script&lang=ts"

import "./IssueHoupiaoList.vue?vue&type=style&index=0&id=96a0eb9c&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a0eb9c"]])

export default __exports__